import { computed } from 'vue';
import { IActUserToAdd } from '@/models/act/act-access.interface';
import { ProjectDetails, ProjectProduct } from '@studyportals/crm-data-processor-interface';
import datePresenter from '@/presenters/date-presenter';
import actStore from '@/store/act';

export default class ActReviewAndConfirmCode {

	public relevantActAccessEntry = computed((): ProjectDetails | undefined => {
		const id = actStore.actGetters.selectedActInvoiceNumber();
		const relevantEntry = this.actAccessEntries.value.find(entry => entry.invoiceNumber === id);
		if (!relevantEntry) {
			return;
		}

		return relevantEntry;
	});

	public actAccessEntries = computed((): ProjectDetails[] => {
		return actStore.actGetters.actAccessEntries();
	});

	public actUsersToAddAsString = computed((): string => {
		return this.actUsersToAdd.value
			.map(user => user.value)
			.join(', ');
	});

	public actUsersToAdd = computed((): IActUserToAdd[] => {
		return actStore.actGetters.actUsersToAdd();
	});

	public actDashboardsToAddAsString = computed((): string => {
		return this.actDashboardsToAdd.value
			.map(dashboard => dashboard.productName)
			.join(', ');
	});

	public actDashboardsToShowDatesFor = computed((): ProjectProduct[] => {
		if (this.sameDatesPerDashboard.value) {
			return [this.actDashboardsToAdd.value[0]];
		}

		return this.actDashboardsToAdd.value;
	});

	public actDashboardsToAdd = computed((): ProjectProduct[] => {
		return actStore.actGetters.actDashboardsToAdd();
	});

	public sameDatesPerDashboard = computed((): boolean => {
		return actStore.actGetters.actSameDateForDashboards();
	});

	public transformDateObjectToUTCDateString(date: Date | null): string {
		if (!date) {
			return 'invalid date';
		}

		return datePresenter.transformDateObjectToUTCDateString(date);
	}
}
